export const appPageTransition = {"name":"page","mode":"out-in"}

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"color-scheme","content":"light"},{"name":"supported-color-schemes","content":"light"},{"name":"viewport","content":"viewport-fit=cover, width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0"},{"name":"theme-color","content":"#317EFB"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-status-bar-style","content":"default"},{"name":"apple-mobile-web-app-title","content":"SupportApp"},{"name":"mobile-web-app-capable","content":"yes"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-icon-180x180.png"},{"rel":"apple-touch-icon","sizes":"152x152","href":"/apple-icon-152x152.png"},{"rel":"apple-touch-icon","sizes":"144x144","href":"/apple-icon-144x144.png"},{"rel":"apple-touch-icon","sizes":"120x120","href":"/apple-icon-120x120.png"},{"rel":"apple-touch-icon","sizes":"114x114","href":"/apple-icon-114x114.png"},{"rel":"apple-touch-icon","sizes":"76x76","href":"/apple-icon-76x76.png"},{"rel":"apple-touch-icon","sizes":"72x72","href":"/apple-icon-72x72.png"},{"rel":"apple-touch-icon","sizes":"60x60","href":"/apple-icon-60x60.png"},{"rel":"apple-touch-icon","sizes":"57x57","href":"/apple-icon-57x57.png"},{"rel":"manifest","href":"/manifest.json"}],"style":[],"script":[],"noscript":[],"titleTemplate":"%s | SupportApp"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appViewTransition = true

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = true

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true